import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { InhabilitarBeneficiario} from './InhabilitarBeneficiario.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'InhabilitarBeneficiario',
        component: InhabilitarBeneficiario,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'InhabilitarBeneficiario'
        } 
    }
];

@NgModule({
    declarations: [
        InhabilitarBeneficiario
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        InhabilitarBeneficiario
    ],
    bootstrap: [InhabilitarBeneficiario]
})

export class InhabilitarBeneficiarioModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/InhabilitarBeneficiario/InhabilitarBeneficiario.module.ts